import { useState } from 'react';
import { Printer } from 'lucide-react';
import { Button } from '@zt/ui';
import { HelpTip } from '../../lib/help';
import { useI18n, useT } from '../../lib/i18n';

/**
 * Raporun yazdırılması ve PDF (F8-10, ADR-810): tarayıcının yazdırma penceresi kullanılır ("PDF olarak kaydet").
 * Sunucuda PDF üretilmez; ekrandaki rakam ve grafikler olduğu gibi basılır. Sayfa `PageFrame printable` ile açılır,
 * süzgeç ve düğmeler `print:hidden` ile gizlenir; başlık bu bileşenle yalnızca kâğıtta görünür.
 */
export function PrintButton({ size = 'md' }: { size?: 'sm' | 'md' }) {
  const t = useT();
  return (
    <span className="inline-flex items-center gap-1 print:hidden">
      <Button variant="secondary" size={size} onClick={() => window.print()}>
        <Printer className="h-4 w-4" aria-hidden />
        {t('admin.reports.print')}
      </Button>
      <HelpTip k="reports.print" />
    </span>
  );
}

/** Yalnızca baskıda görünen başlık: rapor adı, dönem ve yazdırma zamanı. */
export function PrintHeader({
  title,
  period,
  lines = [],
}: {
  title: string;
  period?: { from: string; to: string };
  lines?: string[];
}) {
  const t = useT();
  const { formatDate } = useI18n();
  // Yazdırma zamanı sayfa açıldığında sabitlenir; her çizimde değişmez.
  const [at] = useState(() => new Date().toISOString());
  return (
    <header className="hidden print:block">
      <h1 className="text-xl font-semibold text-ink">{title}</h1>
      {period && (
        <p className="text-sm text-ink-2">
          {t('admin.reports.period')}: {formatDate(period.from, false)} – {formatDate(period.to, false)}
        </p>
      )}
      {lines.map((l) => (
        <p key={l} className="text-sm text-ink-2">
          {l}
        </p>
      ))}
      <p className="text-xs text-ink-3">{t('admin.reports.printedAt', { date: formatDate(at) })}</p>
    </header>
  );
}
